/* eslint-disable import/no-cycle */
/**
 * @typedef {import ('../interfaces/services/IUser.interface').ILogin} ILogin
 * * @typedef {import ('../interfaces/services/IUser.interface').IRecoverPassword} IRecoverPassword
 * @typedef {import ('../interfaces/services/IUser.interface').IRenewPassword} IRenewPassword
 * @typedef {import ('../interfaces/services/IUser.interface').INewUser} INewUser
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<ILogin>} IProcessedPostLogin
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<*>} IProcessedPostLogout
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<ILogin>} IProcessedPostJwtToken
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<IRecoverPassword>} IProcessedPostRecoverPassword
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<IRenewPassword>} IProcessedPostRenewPassword
 *  @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<INewUser>} IProcessedPostNewUser
 */

import { callDeleteExternalApi, callGetExternalApi, callPostExternalApi, callPutExternalApi } from '../utils/externalApiCall';

// @ts-ignore
const baseURL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_BASE_CONTEXT_SII}`;

/**
 * Listado de rutas del backend
 *
 * @return {Object.<string,string>}
 */
const getBackendUrl = (role) => ({
  POST_LOGIN: `${baseURL}/public/user/login`,
  POST_LOGOUT: `${baseURL}/private/user/logout`,
  POST_JWT_TOKEN: `${baseURL}/public/user/jwtToken`,
  POST_NEW_USER: `${baseURL}/private/user`,
  PUT_EDIT_USER: `${baseURL}/private/user`,
  POST_RECOVER_PASSWORD: `${baseURL}/public/user/recover-password`,
  POST_RENEW_PASSWORD: `${baseURL}/private/user/change-password`,
  GET_USERS: `${baseURL}/private/user`,  
  DELETE_USER: `${baseURL}/private/user`,
  GET_USERS_BY_ROLE: `${baseURL}/private/user/role/${role}`,
});

/**
 * @returns {Promise<IProcessedPostLogin>}
 */
const postLogin = async ({ data }) => callPostExternalApi({ url: getBackendUrl().POST_LOGIN, data });

/**
 * @returns {Promise<IProcessedPostLogout>}
 */
const postLogout = async () => callPostExternalApi({ url: getBackendUrl().POST_LOGOUT });

/**
 * @returns {Promise<IProcessedPostJwtToken>}
 */
const postJwtToken = async ({ data }) => callPostExternalApi({ url: getBackendUrl().POST_JWT_TOKEN, data });

/**
 * @returns {Promise<IProcessedPostRecoverPassword>}
 */
const postRecoverPassword = async ({ data }) =>
  callPostExternalApi({ url: getBackendUrl().POST_RECOVER_PASSWORD, data });

/**
 * @returns {Promise<IProcessedPostRenewPassword>}
 */
const postRenewPassword = async ({ data }) => callPostExternalApi({ url: getBackendUrl().POST_RENEW_PASSWORD, data });

/**
 * @returns {Promise<*>}
 */
const getUsers = async () => callGetExternalApi({ url: getBackendUrl().GET_USERS });

/**
 * @returns {Promise<*>}
 */
const getUserById = async (id) => callGetExternalApi({ url: `${getBackendUrl().GET_USERS}/${id}` });

/**
 *
 * @returns {Promise<IProcessedPostNewUser>}
 */

const postNewUser = async ({ data }) => callPostExternalApi({ url: getBackendUrl().POST_NEW_USER, data });

/**
 *
 * @returns {Promise<*>}
 */

const putEditUser = async ({ data }) => callPutExternalApi({ url: getBackendUrl().PUT_EDIT_USER, data });

/**
 * @return {Promise<*>}
 */
const deleteUser = async (id) => callDeleteExternalApi({ url: `${getBackendUrl().DELETE_USER}/${id}` });

/**
 * @returns {Promise<*>}
 */
const getUsersByRole = async (role) => callGetExternalApi({ url: getBackendUrl(role).GET_USERS_BY_ROLE });

export {
  postLogin,
  postLogout,
  postJwtToken,
  postRecoverPassword,
  postRenewPassword,
  getUsers,
  getUsersByRole,
  postNewUser,
  deleteUser,
  getUserById,
  putEditUser,
};
